import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fa-qt2-text',
  templateUrl: './qt2-text.component.html',
  styleUrls: ['./qt2-text.component.css'],
})
export class Qt2TextComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
